import { render, staticRenderFns } from "./ArchiveInterpretation.vue?vue&type=template&id=0be4ffda"
import script from "./ArchiveInterpretation.vue?vue&type=script&lang=js"
export * from "./ArchiveInterpretation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports